import { CountryCodeEnum } from 'features/common/types';
import itauLogo from '../assets/itau-logo-white.webp';

export interface PromoBannerConfig {
	id: string;
	active: boolean;
	countries: CountryCodeEnum[] | 'ALL';
	backgroundColor: string;
	logo?: string;
	image?: string;
	title: string;
	description: string;
	startDateTime?: string; // formato ISO con timezone GMT
	endDateTime?: string; // formato ISO con timezone GMT
	timezone?: string; // ej: 'GMT-4'
	createdAt?: string; // para prioridad por fecha de creación
}

export const promoBanners: PromoBannerConfig[] = [
	{
		id: 'itau-paraguay-nov-2024',
		active: true,
		countries: [CountryCodeEnum.PARAGUAY],
		backgroundColor: '#FF6200', // naranja Itaú
		logo: itauLogo,
		title: 'tus puntos valen X 2 ⭐️',
		description: 'y 15 cuotas sin intereses del 19 al 21 de NOV.',
		// Las fechas se interpretan como si fueran en el timezone especificado (GMT-4)
		// y se convierten automáticamente a GMT para la comparación
		// 19 de noviembre 00:00 GMT-4 = 19 de noviembre 04:00 GMT
		startDateTime: '2025-11-19T00:00:00Z', // Se interpreta como hora local GMT-4
		endDateTime: '2025-11-21T23:59:59Z', // Se interpreta como hora local GMT-4
		timezone: 'GMT-3', // timezone de Paraguay
		createdAt: '2025-11-08T00:00:00Z',
	},
];
